import { PropsWithChildren } from "react";

const SectionContent = ({ children }: PropsWithChildren) => (
  <div className="w-3/4">{children}</div>
);

export default SectionContent;
